import { render, staticRenderFns } from "./CloudAnthology.vue?vue&type=template&id=78ad1e63&scoped=true&"
import script from "./CloudAnthology.vue?vue&type=script&lang=ts&"
export * from "./CloudAnthology.vue?vue&type=script&lang=ts&"
import style0 from "./CloudAnthology.vue?vue&type=style&index=0&id=78ad1e63&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad1e63",
  null
  
)

export default component.exports